import React, { Fragment } from "react";
import { Menu, Transition } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/24/solid";
import DateInput from "../DateInput";
import CustomCombobox from "../CustomCombobox";

function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}

function FilterActionButtons({ onClear, onApply }) {
    return (
        <div className="flex flex-col gap-3 sm:flex-row">
            <button
                onClick={onClear}
                className="w-full rounded-md border border-[#D1D5DB] bg-white px-2 py-2 text-sm font-medium shadow-sm dark:border-gray-700 dark:bg-gray-900"
            >
                Borrar filtros
            </button>
            <button
                onClick={onApply}
                className="w-full rounded-md border border-transparent bg-primary px-2 py-2 text-sm font-medium text-white shadow-sm"
            >
                Aplicar filtro
            </button>
        </div>
    );
}

export function ReportFilterMenu({
    label,
    children,
    buttonClassName = "",
    panelClassName = "",
}) {
    return (
        <Menu as="div" className="relative inline-block text-left">
            <Menu.Button
                className={classNames(
                    "inline-flex w-full justify-center gap-x-1.5 rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm shadow-sm dark:border-slate-700 dark:bg-slate-900",
                    buttonClassName,
                )}
            >
                {label}
                <ChevronDownIcon className="-mr-1 h-5 w-5" aria-hidden="true" />
            </Menu.Button>
            <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
            >
                <Menu.Items
                    className={classNames(
                        "absolute left-0 right-auto z-[60] mt-2 w-[min(20rem,calc(100vw-2rem))] origin-top-left rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none dark:bg-gray-900 sm:w-64 lg:left-auto lg:right-0 lg:origin-top-right",
                        panelClassName,
                    )}
                >
                    <div className="flex flex-col gap-3 px-5 py-4">{children}</div>
                </Menu.Items>
            </Transition>
        </Menu>
    );
}

export function ReportDateFilterMenu({
    handleFromDate,
    handleToDate,
    onClear,
    onApply,
    label = "Fecha",
}) {
    return (
        <ReportFilterMenu label={label}>
            <DateInput handleChange={handleFromDate} name="fromDate" label="Desde" />
            <DateInput handleChange={handleToDate} name="toDate" label="Hasta" />
            <FilterActionButtons onClear={onClear} onApply={onApply} />
        </ReportFilterMenu>
    );
}

export function ReportComboboxFilterMenu({
    label,
    comboboxLabel,
    options,
    handleChange,
    name,
    value,
    onClear,
    onApply,
    multiple = true,
    onQueryChange,
}) {
    return (
        <ReportFilterMenu label={label}>
            <CustomCombobox
                value={value}
                multiple={multiple}
                required={true}
                options={options}
                handleChange={handleChange}
                name={name}
                label={comboboxLabel}
                onQueryChange={onQueryChange}
            />
            <FilterActionButtons onClear={onClear} onApply={onApply} />
        </ReportFilterMenu>
    );
}

export function ReportCustomFilterMenu({
    label,
    children,
    onClear,
    onApply,
}) {
    return (
        <ReportFilterMenu label={label}>
            {children}
            <FilterActionButtons onClear={onClear} onApply={onApply} />
        </ReportFilterMenu>
    );
}